interface SelectOption {
	value: string;
	label: string;
	disabled?: boolean;
}

interface SelectProps {
	value: string;
	onChange: (value: string) => void;
	options: SelectOption[];
	label?: string;
	className?: string;
}

export function Select({ value, onChange, options, label, className = "" }: SelectProps) {
	return (
		<label className={`flex flex-col gap-1 ${className}`}>
			{label && (
				<span className="text-xs font-medium text-text-muted uppercase tracking-wider">
					{label}
				</span>
			)}
			<select
				value={value}
				onChange={(e) => onChange(e.target.value)}
				className="bg-bg-tertiary text-text-primary border border-border-default rounded-md px-3 py-1.5 text-sm outline-none focus:border-accent-primary transition-colors cursor-pointer"
			>
				{options.map((opt) => (
					<option key={opt.value} value={opt.value} disabled={opt.disabled}>
						{opt.label}
					</option>
				))}
			</select>
		</label>
	);
}
